import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const settingsJourneyRoutes = [
  {
    id: 'settings-email-add',
    trackingName: 'Settings Email Add',
    path: 'settings/email/add',
    lazy: async () => ({
      Component: (await import('../components/JourneySettingsEmailAdd')).JourneySettingsEmailAdd,
    }),
  },
  {
    id: 'settings-phone-number-add',
    trackingName: 'Settings Phone Number Add',
    path: 'settings/phone/add',
    lazy: async () => ({
      Component: (await import('../components/JourneySettingsPhoneNumberAdd')).JourneySettingsPhoneNumberAdd,
    }),
  },
  {
    id: 'add-cashtag',
    trackingName: 'Add Cashtag',
    path: 'add-cashtag',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashtag')).JourneyCashtag,
      props: { isEditing: false },
    }),
  },
  {
    id: 'edit-cashtag',
    trackingName: 'Edit Cashtag',
    path: 'edit-cashtag',
    lazy: async () => ({
      Component: (await import('../components/JourneyCashtag')).JourneyCashtag,
      props: { isEditing: true },
    }),
  },
  {
    id: 'remove-instrument',
    trackingName: 'Remove Instrument',
    path: 'settings/instrument/remove/:instrumentToken',
    lazy: async () => ({
      Component: (await import('../components/JourneyRemoveInstrument')).JourneyRemoveInstrument,
    }),
  },
  {
    id: 'settings-disable-security-lock',
    trackingName: 'Disable Security Lock',
    path: 'settings/security-lock/disable',
    lazy: async () => ({
      Component: (await import('../components/JourneyUnlockSecurityLock')).JourneyUnlockSecurityLock,
    }),
  },
  {
    id: 'settings-link-instrument',
    trackingName: 'Link Instrument',
    path: 'settings/instrument/link/:instrumentType',
    lazy: async () => ({
      Component: (await import('../components/JourneyLinkInstrument')).JourneyLinkInstrument,
    }),
  },
  {
    id: 'settings-relink-instrument',
    trackingName: 'ReLink Instrument',
    path: 'settings/instrument/relink/:instrumentType',
    lazy: async () => ({
      Component: (await import('../components/JourneyLinkInstrument')).JourneyReLinkInstrument,
    }),
  },
] as const satisfies JourneyRoute[]
